import {
  Pagination as TablePagination,
  PaginationCounter,
  PaginationCounterProps,
} from '@otp/ui';

export const Pagination = (
  props: PaginationCounterProps & { onPageChange: (page: number) => void },
) => {
  const { count, page, rowsPerPage, onPageChange } = props;

  return (
    <div className="flex justify-between items-center my-2">
      <PaginationCounter count={count} rowsPerPage={rowsPerPage} page={page} />
      <div className="flex justify-end">
        <TablePagination
          page={page}
          count={count}
          rowsPerPage={rowsPerPage}
          onChange={onPageChange}
        />
      </div>
    </div>
  );
};
